import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import tailwindConfig from 'tailwind-config'
import _debounce from 'lodash/debounce.js'
import { useDebugger } from '@/shared/composables/useDebugger.js'

export const useScreenWidth = () => {
  const { $debug } = useDebugger()
  const screenWidth = ref(window.innerWidth)

  const tailwindScreens = computed(() => {
    return Object.fromEntries(
      Object.entries(tailwindConfig.theme.screens).map(([key, value]) => [
        key,
        Number(value.replace('px', '')),
      ]),
    )
  })

  const recalculateScreenWidth = () => {
    screenWidth.value = window.innerWidth
  }

  const debounceRecalculateScreenWidth = _debounce(() => {
    recalculateScreenWidth()
    $debug(
      `Debounce - Screen width recalculated, width: ${screenWidth.value}px`,
    )
  }, 1000)

  onMounted(() => {
    window.addEventListener('resize', debounceRecalculateScreenWidth)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', debounceRecalculateScreenWidth)
  })

  return {
    tailwindScreens,
    screenWidth,
  }
}
